import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ScreenSizeService } from '../../../../core/services/screen-size.service';
import { EventsService } from '../../../../core/services/events.service';
import {
    SCREEN_SIZE_WAS_CHANGED,
    CLIENT_WIDTH_WAS_CHANGED,
    CARD_WIDTH, CARD_HEIGHT,
    CARD_MARGIN
} from "../../../../app.constants";

@Component({
    selector: 'product-carousel',
    templateUrl: './product-carousel.component.html',
    styleUrls: ['./product-carousel.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ProductCarouselComponent implements OnInit{
    @Input() productList: any;
    offset: string;
    offsetValue: number;
    itemsOnScreen: number;
    itemCounter: number;

    constructor( private screenSizeService: ScreenSizeService,
                 private eventsService: EventsService) {
        if (this.isMiddle() || this.isLarge()) {
            this.makeCarousel();
        } else {
            this.makeSmallView();
        }

    }

    ngOnInit() {
        this.eventsService.on(SCREEN_SIZE_WAS_CHANGED).subscribe(() => {
            if (this.isSmall()) {
                this.makeSmallView();
            } else {
                this.makeCarousel();
            }
        });
    }

    makeCarousel() {
        this.offset = '0vw';
        this.offsetValue = 0;
        this.itemsOnScreen = 4;
        this.itemCounter = this.itemsOnScreen;
    }

    makeSmallView() {
        this.offset = '0vw';
        this.offsetValue = 0;
        this.itemsOnScreen = 1;
        this.itemCounter = this.itemsOnScreen;
    }

    moveToNext() {
        if (this.itemCounter + 1 <= this.productList.length) {
            this.itemCounter++;
            this.offsetValue -= CARD_WIDTH;
            this.offset = this.offsetValue + 'vw';
        }
    }

    moveToPrev() {
        if (this.itemCounter - 1 >= this.itemsOnScreen) {
            this.itemCounter--;
            this.offsetValue += CARD_WIDTH;
            this.offset = this.offsetValue + 'vw';
        }
    }

    isRightArrowRender() {
        if (this.itemCounter < this.productList.length ) {
            return true;
        }
        if (this.itemCounter === this.productList.length) {
            return false;
        }
    }

    isLeftArrowRender() {
        if (this.itemCounter > this.itemsOnScreen) {
            return true;
        }
        if (this.itemCounter === this.itemsOnScreen) {
            return false;
        }
    }

    isLarge() {
        return this.screenSizeService.isLarge();
    }

    isMiddle() {
        return this.screenSizeService.isMiddle();
    }

    isSmall() {
        return this.screenSizeService.isSmall();
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/home/components/product-carousel/product-carousel.component.ts